import { motion } from "framer-motion";
import { useState } from "react";

const testimonials = [
    { quote: "In just seven days across our two inbound agents, we had 1,700 phone calls answered or fielded by the agent. The combined call duration was about 70 hours.", name: "Harry Nalbandyan", role: "Founder, Partner", tint: "coral" },
    { quote: "The Lexafide IVR answers questions as they come in and learns what it isn't answering yet — so my people are free. Not chasing doctor's offices, not chasing adjusters.", name: "Josh Kwartler", role: "COO", tint: "forest" },
    { quote: "Our receptionists were burning out. Calls weren't being answered in a timely manner — they were going to voicemail. And that is just highly unacceptable for us.", name: "John Richmond", role: "Founder, Partner", tint: "forest" },
    { quote: "Our attorneys are more prepared in their first conversation with the client. They're getting a readout of the case manager's call and the intake call.", name: "Brian Ricci", role: "Founder, Partner", tint: "coral" },
];

const MOBILE_LIMIT = 2;

const TestimonialsSection = () => {
    const [showAll, setShowAll] = useState(false);
    return (
        <section data-testid="testimonials-section" className="relative py-24 md:py-32">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="mb-12 md:mb-14 max-w-4xl"
                >
                    <span className="eyebrow-pill">Testimonials</span>
                    <h2 className="font-display text-[clamp(2rem,4.2vw,3.2rem)] leading-[1.04] tracking-tight font-semibold text-[var(--ink)] mt-5">
                        From founders whose names <span className="accent-blue">are on the door.</span>
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
                    {testimonials.map((t, i) => (
                        <motion.figure
                            key={t.author || i}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
                            data-testid={`testimonial-${i}`}
                            className={`${t.tint === "coral" ? "card-coral" : "card-forest"} p-7 md:p-9 ${
                                i >= MOBILE_LIMIT && !showAll ? "hidden md:block" : ""
                            }`}
                        >
                            <i className={`fa-solid fa-quote-left text-2xl ${t.tint === "coral" ? "accent-coral" : "accent-forest"} opacity-60 mb-4`} />
                            <blockquote className="font-display font-medium text-[1.25rem] md:text-[1.35rem] leading-[1.3] text-[var(--ink)] mb-6">
                                {t.quote}
                            </blockquote>
                            <figcaption className={`flex items-center gap-3 pt-5 border-t ${t.tint === "coral" ? "border-[var(--coral)]/20" : "border-[var(--forest)]/20"}`}>
                                <div className={`w-10 h-10 rounded-full ${t.tint === "coral" ? "bg-[var(--coral)]" : "bg-[var(--forest)]"} flex items-center justify-center text-[var(--paper)] font-display`}>
                                    {t.name.charAt(0)}
                                </div>
                                <div>
                                    <div className="text-sm text-[var(--ink)]">{t.name}</div>
                                    <div className="text-xs text-[var(--ink-dim)] font-mono">{t.role}</div>
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>

                {/* Mobile-only "Show more" toggle */}
                {!showAll && testimonials.length > MOBILE_LIMIT && (
                    <div className="mt-8 flex justify-center md:hidden">
                        <button
                            type="button"
                            onClick={() => setShowAll(true)}
                            data-testid="testimonials-show-more"
                            className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-[var(--border-strong)] bg-[var(--paper)] text-[var(--ink)] font-medium text-sm hover:bg-[var(--ink)] hover:text-white hover:border-[var(--ink)] transition-colors"
                        >
                            Read {testimonials.length - MOBILE_LIMIT} more
                            <i className="fa-solid fa-arrow-down text-xs" />
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default TestimonialsSection;
